import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Clock, Home, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function VendorPending() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full text-center"
      >
        <div className="w-20 h-20 rounded-full bg-yellow-100 flex items-center justify-center mx-auto mb-6">
          <Clock className="w-10 h-10 text-yellow-600" />
        </div>
        
        <h1 className="text-2xl font-bold mb-4">Registration Pending Approval</h1>
        
        <p className="text-muted-foreground mb-8">
          Thanks for registering your food truck! Our team will review your application 
          and get back to you within 1-2 business days.
        </p>

        <div className="bg-card rounded-xl p-6 border mb-8">
          <h3 className="font-medium mb-3">What happens next?</h3>
          <ul className="text-sm text-muted-foreground text-left space-y-2">
            <li className="flex items-start gap-2">
              <span className="text-primary">1.</span>
              <span>Our team reviews your truck details and menu</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary">2.</span>
              <span>You'll receive an email once approved</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary">3.</span>
              <span>Your truck will appear to students on SkipdQ</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary">4.</span>
              <span>Start receiving orders and making sales!</span>
            </li>
          </ul>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/">
            <Button variant="outline" className="gap-2">
              <Home className="w-4 h-4" />
              Back to Home
            </Button>
          </Link>
          <a href="mailto:support@skipdq.me">
            <Button variant="ghost" className="gap-2">
              <Mail className="w-4 h-4" />
              Contact Support
            </Button>
          </a>
        </div>
      </motion.div>
    </div>
  );
}
